export enum QuestionSupport {
  None,
  Summary,
  Collecting
}
